/**
 * 公共组件引入
 * @creater liux
 * @Email   liuxing@autobio.com.cn
 * @Date    2019年8月8日 10:00:00
 */
import CommonDialog from '@public/commondialog' 
import CommonSelect from '@public/commonselect' 
import CommonDatagrid from '@public/commondatagrid' 
export default {
  CommonDialog,CommonDatagrid,CommonSelect
}